import React from "react";
import CropComponent from "../../components/Crop/Crop.js";

const Crop = () => <CropComponent />;

export default Crop;
